module.exports = __webpack_public_path__ + "static/media/question-mark.a0f5d623.svg";